import { Configuration, DefaultHeaders, NgxOAuthClient } from 'ngx-oauth-client';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/takeUntil';
import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { MzToastService } from 'ng2-materialize';
import { Subject } from 'rxjs/Subject';

@DefaultHeaders({
  'Content-Type': 'application/json',
  Accept: 'application/json'
})
@Configuration({
  host: environment.autServer,
  token: 'login'
})
@Injectable()
export class Api extends NgxOAuthClient {
  private cancelPendingRequests$ = new Subject<void>();

  get onCancelPendingRequests() {
    return this.cancelPendingRequests$.asObservable();
  }

  shown = false;
  constructor(
    http: HttpClient,
    private router: Router,
    private toast: MzToastService
  ) {
    super(http);
  }

  errorInterceptor(request, error) {
    if (error.status === 401) {
      this.cancelPendingRequests$.next();
      this.clearToken();
      this.router.navigate(['/']).then(() => {
        if (!this.shown) {
          this.shown = true;
          this.toast.show('Proszę zalogować się ponownie', 4000, null, () => {
            this.shown = false;
          });
        }
      });
      return Observable.throw('unauthorized');
    }
    if (error && error.error && error.error.message) {
      return Observable.throw(error.error.message);
    } else {
      return Observable.throw(error.status);
    }
  }

  requestInterceptor(request) {
    const token = this.fetchToken('access_token');
    if (token) {
      return request.setHeaders({ Authorization: 'Bearer ' + token });
    }
    return request;
  }
}

@Injectable()
export class HttpCancelInterceptor implements HttpInterceptor {
  constructor(private httpCancelService: Api) {}

  intercept<T>(
    req: HttpRequest<T>,
    next: HttpHandler
  ): Observable<HttpEvent<T>> {
    return next
      .handle(req)
      .takeUntil(this.httpCancelService.onCancelPendingRequests);
  }
}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/core/api.ts